import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const GooglePmaxGate = React.lazy(() => import("./GooglePmax.gate"));

const GooglePmaxLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <GooglePmaxGate />
  </React.Suspense>
);

export default () => <GooglePmaxLoadable />;
